<template>
  <div class="sidebar-wrap" :class="{ 'sidebar-active': active }">
    <div class="sidebar">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.sidebar-wrap {
  @apply absolute w-full h-full;

  left: -100%;
  transition: left 300ms ease-in;
  z-index: 2;

  &.sidebar-active {
    left: 0;
  }

  @screen md {
    @apply relative  w-gr-small;
    left: 0;
  }

  @screen xl {
    @apply max-w-sm;
  }
}

.sidebar {
  @apply h-full bg-white;
}
</style>
